import type { Locale } from '@/i18n/config';

export const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  zh: '中文',
  ja: '日本語',
  ko: '한국어',
  pt: 'Português',
  de: 'Deutsch',
  hi: 'हिन्दी',
  ru: 'Русский',
  tr: 'Türkçe',
  it: 'Italiano',
  id: 'Bahasa Indonesia',
  vi: 'Tiếng Việt',
  nl: 'Nederlands',
  pl: 'Polski',
  th: 'ไทย',
  uk: 'Українська',
  ro: 'Română',
  tl: 'Filipino',
  sv: 'Svenska',
};
